export default "__VITE_ASSET__C08IFDya__"